module.exports = __webpack_public_path__ + "img/7.b240ae0a.jpg";